import React, { useEffect, useState } from "react";
import api from "../../utils/axios.config";
import { baseUrl } from "../../utils/url";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Facebook, Globe, Mail, Award } from "lucide-react";

const TopDonor = () => {
  const [donorPartners, setDonorPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleGetDonorPartner = async () => {
      try {
        setLoading(true);
        const { data } = await api.get("donor-partner");
        setDonorPartners(data.donorPartner);
      } catch (error) {
        console.error("Error fetching donor partners:", error);
      } finally {
        setLoading(false);
      }
    };
    handleGetDonorPartner();
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="py-16 px-4 max-w-7xl mx-auto">
      {/* Header with decorative elements */}
      <div className="text-center mb-10">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Award className="h-6 w-6 text-primary/70" />
          </span>
          ডোনার এন্ড পাটর্নার
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Award className="h-6 w-6 text-primary/70" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full mb-4"></div>
        <p className="text-gray-600 max-w-2xl mx-auto">
          আমাদের সাথে যারা অবদান রেখে যাচ্ছেন এবং সমাজের উন্নয়নে সাহায্য করছেন
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      ) : (
        <div className="mx-auto w-full">
          <Carousel
            swipeable
            draggable
            showDots
            responsive={responsive}
            autoPlay
            ssr
            infinite
            autoPlaySpeed={3000}
            keyBoardControl
            customTransition="all 500ms ease"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            {donorPartners.map((donorPartner) => (
              <div key={donorPartner._id} className="flex justify-center p-4">
                <div
                  className="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px] border border-gray-100 w-full max-w-xs"
                  data-aos="fade-up"
                >
                  <div className="bg-primary/10 p-6 flex justify-center items-center">
                    <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-white shadow-md">
                      <img
                        src={`${baseUrl}${donorPartner?.imageUrl}`}
                        alt={donorPartner.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className="p-6 text-center">
                    <h2 className="font-bold text-xl text-gray-800 mb-2">
                      {donorPartner.name}
                    </h2>
                    <p className="text-gray-600 mb-1">
                      {donorPartner.designation}
                    </p>
                    <p className="text-gray-600 mb-4">
                      {donorPartner.institute}
                    </p>

                    <div className="flex justify-center space-x-4 mt-4">
                      {donorPartner.facebookUrl && (
                        <a
                          href={donorPartner.facebookUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-2 bg-blue-100 rounded-full text-blue-600 hover:bg-blue-600 hover:text-white transition-colors duration-300"
                          aria-label="Facebook"
                        >
                          <Facebook className="h-5 w-5" />
                        </a>
                      )}
                      {donorPartner.webUrl && (
                        <a
                          href={donorPartner.webUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-2 bg-purple-100 rounded-full text-purple-600 hover:bg-purple-600 hover:text-white transition-colors duration-300"
                          aria-label="Website"
                        >
                          <Globe className="h-5 w-5" />
                        </a>
                      )}
                      {donorPartner.emailUrl && (
                        <a
                          href={`mailto:${donorPartner.emailUrl}`}
                          className="p-2 bg-red-100 rounded-full text-red-600 hover:bg-red-600 hover:text-white transition-colors duration-300"
                          aria-label="Email"
                        >
                          <Mail className="h-5 w-5" />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
};

export default TopDonor;
